<div class="upload-file-container">
  <div class="file-name">
    <span class="file-name-label">{{ file()?.name ?? 'Archivo no seleccionado...' }}</span>
    @if (file() && !approvalComplete()) {
      &nbsp;<fa-icon class="trash-can" (click)="onDelete.emit(true)" [icon]="faTrashCan"></fa-icon>
    }
    <input (change)="onLoadFile($event)" type="file" accept=".pdf" multiple="false" hidden #fileInput>
  </div>
  <div class="controls">
    <button [disabled]="approvalComplete()" (click)="fileInput.click()" class="btn btn-sm btn-zazz-dark" type="button">Cargar</button>
    <button (click)="previewDocument()" class="btn btn-sm btn-secondary" type="button" [disabled]="!file()">Visualizar</button>
  </div>
</div>